function showOverlay(time = 250, allowScroll = false) {
    const $body = $('body'),
        bodyWidth = $body.innerWidth();

    let scrollbarWidth;

    setTimeout(() => {
        $('.c-overlay').addClass('is-active');

        if (!allowScroll) {
            $body.addClass('is-overlayed');

            scrollbarWidth = $body.innerWidth() - bodyWidth;

            if (scrollbarWidth > 0) {
                $body.css('paddingRight', scrollbarWidth);
            }

            freezeScroll();
        }
    }, 1);
}

function hideOverlay(time = 250) {
    unfreezeScroll();

    setTimeout(() => {
        $('.c-overlay').removeClass('is-active');
        $('body').css('paddingRight', '').removeClass('is-overlayed');
    }, 0);
}
